import { Paper, PaperTypeMap } from "@mui/material"
import { DefaultComponentProps } from "@mui/material/OverridableComponent"
import React from "react"
import { Colors } from "../../../../../view/design/color/Colors"

export const BlockPapper = (props: DefaultComponentProps<PaperTypeMap>) => <Paper {...props}
  sx={{
    background: Colors.bgSurface,
    padding: '24px',
    borderRadius: '8px',
    width: '100%',
    height: '100%',
    display: 'flex',
    ...props?.sx,
  }}
/>